import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages/Home';
import './styles/globalstyles.css';
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);